import { useMantineTheme } from '@mantine/core';
import { colors } from '../../config';
/* eslint-disable */
export const ChevronDown = () => {
  const theme = useMantineTheme();

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
      <path
        d="M10.8789 1.5C11.4414 0.9375 11.0352 0 10.2852 0H2.00391C1.25391 0 0.847656 0.9375 1.41016 1.5L5.53516 5.75C5.69141 5.9375 5.91016 6 6.16016 6C6.37891 6 6.59766 5.9375 6.75391 5.75L10.8789 1.5Z"
        fill={theme.colorScheme === 'light' ? colors.B60 : 'white'}
      />
    </svg>
  );
};
